'use strict';
import angular from 'angular';
import './scripts/ratecard.ctrls';
import './scripts/ratecard.directives';

import rateCardHtmlUrl from './views/ratecard.html';
import rateCardContentHtmlUrl from './views/rateCardContent.html';

angular.module('ratecard', [
    'ratecard.ctrls',
    'ratecard.directives'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('ratecard', {
                parent: 'layout',
                url: '/admin/tapIORateCard',
                templateUrl: rateCardHtmlUrl,
                controller: 'RateCardController',
            })
            .state('rateCardContent', {
                parent: 'layout',
                url: '/admin/rateCardContent/:typeId',
                templateUrl: rateCardContentHtmlUrl,
                controller: 'RateCardController',
            })
    }]);